import FuzerIcon from '../../assets/icons/fuzer-loader-icon.svg'

const Loader = ({
	size,
}) => (
	<img className={`rounded-full h-[${size}px] rounded-full animate-spin`} src={FuzerIcon} alt="app loader" />
) 

export default Loader